// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3Wohk","footer":"ModalUpdate_footer__GhIkM"};